/*
 * @nu-art/logger - Flexible logging infrastructure with multiple output targets
 * Copyright (C) 2026 Adam van der Kruk aka TacB0sS
 * Licensed under the Apache License, Version 2.0
 */
/**
 * Log levels ordered from most verbose (lowest priority) to least verbose (highest priority).
 *
 * Used for filtering and controlling log output granularity.
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel["Verbose"] = "Verbose";
    LogLevel["Debug"] = "Debug";
    LogLevel["Info"] = "Info";
    LogLevel["Warning"] = "Warning";
    LogLevel["Error"] = "Error";
})(LogLevel || (LogLevel = {}));
/**
 * Array of log levels in ordinal order (least to most severe).
 *
 * Used for comparisons and determining if a log level meets a threshold.
 */
export const LogLevelOrdinal = [
    LogLevel.Verbose,
    LogLevel.Debug,
    LogLevel.Info,
    LogLevel.Warning,
    LogLevel.Error,
];
//# sourceMappingURL=types.js.map